import React from 'react';
import ProfileDetailView from '~/components/Company/Profile/Detail';

const ProfileDetail = (): React.ReactElement => {
  return <ProfileDetailView />;
};

export default ProfileDetail;
